/**
 * Модуль табов
 */

const defaults = {

};

export default class Tabs {
    constructor(rootElement, options = defaults) {
        this.opts = Object.assign({}, defaults, options);

        this.root = rootElement;
        this.root.classList.add('tabs-root', 'tabs-initialized');

        this.nav = this.root.querySelector('.tabs-nav');
        this.container = this.root.querySelector('.tabs-container');

        for(let i = 0, navItem; navItem = this.nav.children[i]; i++){
            navItem.classList.add('tabs-nav-item');

            if(i == 0){
                navItem.classList.add('tabs-active');
            }

            navItem.addEventListener('click', (e) => {
                this.expandTab(i);
            });
        }

        for(let i = 0, tab; tab = this.container.children[i]; i++){
            tab.classList.add('tabs-tab');

            if(i == 0){
                tab.classList.add('tabs-active');
            }
        }

        this.root.tabs = this;
    }

    expandTab(ind) {
        try {
            let currActiveNav = this.nav.querySelector('.tabs-active');

            if(currActiveNav){
                currActiveNav.classList.remove('tabs-active');
            }
            
            this.nav.children[ind].classList.add('tabs-active');

            let currActiveTab = this.container.querySelector('.tabs-active');

            if(currActiveTab){
                currActiveTab.classList.remove('tabs-active');
            }
            
            this.container.children[ind].classList.add('tabs-active');
        } catch (e) {
            console.error(e.message);
        }
    }
}